import Vue from 'vue'
import VueRouter from 'vue-router'
import { PerfilService } from '../services/PerfilService'
import Bloco from '../views/Bloco.vue'
import Andar from '../views/Andar.vue'
import Corredor from '../views/Corredor.vue'
import Sala from '../views/Sala.vue'
import Ocorrencia from '../views/Ocorrencia.vue'
import Login from '../views/Login.vue'
import MeusChamados from '../views/MeusChamados.vue'
import CadBloco from '../views/cadastro/CadBloco.vue'
import CadAndar from '../views/cadastro/CadAndar.vue'
import CadCorredor from '../views/cadastro/CadCorredor.vue'
import CadSala from '../views/cadastro/CadSala.vue'
import CadSetor from '../views/cadastro/CadSetor.vue'
import CadProblema from '../views/cadastro/CadProblema.vue'
import CadParametro from '../views/cadastro/CadParametro.vue'
import CadUsuario from '../views/cadastro/CadUsuario.vue'
import Local from '../views/gerenciar/Local.vue'
import CadItem from '../views/cadastro/CadItem.vue'
import AcessoNegado from '../views/pages/AcessoNegado.vue'
import NovaSolicitacao from '../views/solicitacao/NovaSolicitacao.vue'
import ListagemSolicitacao from '../views/solicitacao/ListagemSolicitacao.vue'
import ListagemOcorrencia from '../views/ocorrencia/ListagemOcorrencia.vue'
import ListagemChecklist from '../views/checklist/ListagemChecklist.vue'
import NovoChecklist from '../views/checklist/NovoChecklist.vue'
import GeradorRelatorios from '../views/relatorio/GeradorRelatorios.vue'
import Dashboard from '../views/Dashboard.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAdminOrSupervisor: true }
  },
  {
    path: '/bloco',
    name: 'Bloco',
    component: Bloco
  },
  {
    path: '/andar/:idBloco',
    name: 'Andar',
    component: Andar
  },
  {
    path: '/corredor/:idBloco/:idAndar',
    name: 'Corredor',
    component: Corredor
  },
  {
    path: '/sala/:idBloco/:idAndar/:idCorredor',
    name: 'Sala',
    component: Sala
  },
  {
    path: '/ocorrencia/gerenciar',
    name: 'Ocorrências',
    component: ListagemOcorrencia,
    meta: { requiresAdmin: true }
  },
  {
    path: '/ocorrencia/:idAndarSala',
    name: 'Chamado',
    component: Ocorrencia
  },
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/chamados-abertos',
    name: 'Chamados',
    component: MeusChamados
  },
  {
    path: '/cadastro/bloco',
    name: 'Blocos',
    component: CadBloco,
    meta: { requiresAdmin: true }
  },
  {
    path: '/cadastro/andar',
    name: 'Andares',
    component: CadAndar,
    meta: { requiresAdmin: true }
  },
  {
    path: '/cadastro/corredor',
    name: 'Corredores',
    component: CadCorredor,
    meta: { requiresAdmin: true }
  },
  {
    path: '/cadastro/sala',
    name: 'Salas',
    component: CadSala,
    meta: { requiresAdmin: true }
  },
  {
    path: '/cadastro/setor',
    name: 'Setores',
    component: CadSetor,
    meta: { requiresAdmin: true }
  },
  {
    path: '/cadastro/problema',
    name: 'Problemas',
    component: CadProblema,
    meta: { requiresAdmin: true }
  },
  {
    path: '/cadastro/parametro',
    name: 'Parâmetros',
    component: CadParametro,
    meta: { requiresAdmin: true }
  },
  {
    path: '/gerenciar/local',
    name: 'Local',
    component: Local,
    meta: { requiresAdmin: true }
  },
  {
    path: '/checklist/itens',
    name: 'Itens Inventário',
    component: CadItem,
    meta: { requiresAdmin: true }
  },
  {
    path: '/cadastro/usuario',
    name: 'Usuários',
    component: CadUsuario,
    meta: { requiresAdmin: true }
  },
  {
    path: '/error',
    name: 'Acesso Negado',
    component: AcessoNegado
  },
  {
    path: '/solicitacao/inventario/nova',
    name: 'Nova Solicitação de Inventário',
    component: NovaSolicitacao,
    meta: { tipo: 'INVENTARIO', requiresAdminSupervisorOrOperator: true }
  },
  {
    path: '/solicitacao/inventario/lista',
    name: 'Solicitações de Inventário',
    component: ListagemSolicitacao,
    meta: { tipo: 'INVENTARIO', requiresAdminSupervisorOrOperator: true }
  },
  {
    path: '/solicitacao/checklist/nova',
    name: 'Nova Solicitação de Checklist',
    component: NovaSolicitacao,
    meta: { tipo: 'CHECKLIST', requiresAdminSupervisorOrOperator: true }
  },
  {
    path: '/solicitacao/checklist/lista',
    name: 'Solicitações de Checklist',
    component: ListagemSolicitacao,
    meta: { tipo: 'CHECKLIST', requiresAdminSupervisorOrOperator: true }
  },
  {
    path: '/inventario/lista',
    name: 'Listagem de Inventários',
    component: ListagemChecklist,
    meta: { tipo: 'INVENTARIO', requiresAdminSupervisorOrOperator: true }
  },
  {
    path: '/inventario/novo',
    name: 'Cadastro de Inventário',
    component: NovoChecklist,
    meta: { tipo: 'INVENTARIO', requiresAdminSupervisorOrOperator: true }
  },
  {
    path: '/checklist/lista',
    name: 'Listagem de Checklists',
    component: ListagemChecklist,
    meta: { tipo: 'CHECKLIST', requiresAdminSupervisorOrOperator: true }
  },
  {
    path: '/checklist/novo',
    name: 'Cadastro de Checklist',
    component: NovoChecklist,
    meta: { tipo: 'CHECKLIST', requiresAdminSupervisorOrOperator: true }
  },
  {
    path: '/relatorios/gerar',
    name: 'Gerador de Relatórios',
    component: GeradorRelatorios,
    meta: { requiresAdmin: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Route Guards (Segurança de rotas no Frontend)
router.beforeEach((to, from, next) => {
  const perfilService = new PerfilService();

  // Verifica se a rota precisa ser Administrador
  if (to.matched.some(record => record.meta.requiresAdmin)) {
    if (!perfilService.ehAdministrador) {
      return next({ path: '/error' }); // Acesso Negado
    }
  }

  // Verifica se a rota precisa ser Admin ou Supervisor
  if (to.matched.some(record => record.meta.requiresAdminOrSupervisor)) {
    if (!perfilService.ehAdminOuSupervisor) {
      return next({ path: '/error' }); // Acesso Negado
    }
  }

  // Verifica se a rota precisa ser Admin, Supervisor ou Operador
  if (to.matched.some(record => record.meta.requiresAdminSupervisorOrOperator)) {
    if (!perfilService.ehAdminSupervisorOuOperador) {
      return next({ path: '/error' }); // Acesso Negado
    }
  }

  next(); // Pode prosseguir
})

export default router
